/**
 * 결제 로딩 컴포넌트
 * FSD: features/subscription/payment-result/ui
 */

import React from 'react';

export const PaymentLoading: React.FC = () => {
  return (
    <div className="payment-loading">
      <div className="spinner"></div>
      <p>결제 처리 중...</p>
    </div>
  );
};
